import { render, staticRenderFns } from "./ComponentItemsClaim.vue?vue&type=template&id=af514958&scoped=true&"
import script from "./ComponentItemsClaim.vue?vue&type=script&lang=ts&"
export * from "./ComponentItemsClaim.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentItemsClaim.vue?vue&type=style&index=0&id=af514958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af514958",
  null
  
)

export default component.exports